// Reserved for minimal logic that triggers "above the fold"
function setGlobalVariables() {
  window.config = window.config || {}

  document.body.style.setProperty('--initial-height', `${window.innerHeight}px`)

  window.addEventListener('resize', updateGlobalVariables)
  updateGlobalVariables()
}

function updateGlobalVariables() {
  // Used for things like popups, drawers, etc. that need to be constrained within the viewable portion of a scroll-locked window
  document.body.style.setProperty('--inner-height', `${window.innerHeight}px`)

  setHeight({ selector: '.section-header', variable: 'navHeight', property: '--nav-height' })
  setHeight({ selector: '.section-announcement-bar', variable: 'barHeight', property: '--bar-height' })
}

function setHeight({ selector, variable, property }) {
  const element = document.querySelector(selector)

  if (element !== null) {
    window.config[variable] = element.getBoundingClientRect().height
  } else {
    window.config[variable] = 0
  }

  document.body.style.setProperty(property, `${window.config[variable]}px`)
}

setGlobalVariables()
